import React, {useState, useEffect} from "react";
import MetaTags from 'react-meta-tags';
import { Container, Row, Col, CardBody, Card, Button, Form, Label, Input, FormFeedback } from "reactstrap";
import logoImg from "assets/images/logo-light.png";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import toastr from "toastr";
import axios from "axios";
import { TOAST_OPTIONS, Config } from "helpers/backend_helper";
import * as url from "helpers/url_helper";


const ChangePassword = () => {
    const history = useHistory()
    toastr.options = TOAST_OPTIONS;
    const [userId, setUserId] = useState("")
    const [empName, setEmpName] = useState("")
    const [oldPass, setOldPass] = useState("")
    const [newPass, setNewPass] = useState("")
    const [newPass1, setNewPass1] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    
    useEffect(()=>{
        if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            console.log(obj)
            setUserId(obj.id)
            setEmpName(obj.username)
        }
    },[])
 
    const handleSubmit = () =>{
        if(oldPass.trim().length < 4){
            toastr.error("Please enter Old Password")
        }else if((newPass.trim().length < 4) || (newPass1.trim().length < 4)){
            toastr.error("New Password should be minimum 5 characters")
        }else if(newPass != newPass1){
            toastr.error("Please Confirm the new password")
        }else{
            const data = {
                userId     : userId,
                oldPassword: oldPass,
                password   : newPass,
                cPassword  : newPass1
            }
            setIsLoading(true)
            axios.post(url.CHANGEPASSWORD, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == '0'){
                    toastr.error(r.data.message)
                }else{
                    toastr.success(r.data.message)
                    history.push("/login")
                }
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
            })
            
        }
    }

  return (
    <React.Fragment>
    <MetaTags>
      <title>Change Password | {url.COMPANY}</title>
    </MetaTags>
    <div className="home-btn d-none d-sm-block">
      <Link to="/" className="text-dark">
        <i className="fas fa-home h2" />
      </Link>
    </div>
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="overflow-hidden">
              <div className=" bg-soft">
                <Row>
    
                  <Col xs={12}>
                    <div className="text-primary p-4">
                    <img src={logoImg} alt="" className="img-fluid" height="60" />
                  
                    </div>
                  </Col>
                  
                </Row>
              </div>
              
              <CardBody className="pt-0">
               
                <div className="p-2">
                <div className="alert alert-success text-center mb-4" role="alert">Change Password for user <b>{empName}</b></div>

                    <div className="mb-3">
                      <Label className="form-label">Old Password</Label>
                      <Input className="form-control" type="password" onChange={(e)=>setOldPass(e.target.value)} />
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">New Password</Label>
                      <Input className="form-control" type="password" onChange={(e)=>setNewPass(e.target.value)}/>
                    </div>
                    
                    <div className="mb-3">
                      <Label className="form-label">Confirm New Password</Label>
                      <Input className="form-control" type="password" onChange={(e)=>setNewPass1(e.target.value)} />
                    </div>
                    <div className="mt-4">
                    {isLoading?(
                        <button
                            className="btn btn-warning w-md "
                            type="button"
                          >
                            Please wait...
                          </button>
                    ):(
                      <button
                        className="btn btn-primary btn-block "
                        onClick={()=>handleSubmit()}
                      >
                        Save
                      </button>
                      )}
                    </div>
                </div>
                <div className="mt-5 text-center">

            </div>
              </CardBody>
            </Card>
           
          </Col>
        </Row>
      </Container>
    </div>
  </React.Fragment>
);

};
export default ChangePassword;
